import Administracioninventory from "components-base/pages/administracioninventory";
export const Inventory = () => {
  return (
    <div className="flex w-full flex-col gap-5">
      <Administracioninventory />
    </div>
  );
};
export default Inventory;
